import {Route} from '@angular/router';
import {DashboardComponent} from './pages/dashboard/dashboard.component';

import {LayoutDefaultComponent} from './common/layout/default/layout-default.component';
import {EnergyChartComponent} from './pages/dashboard/components/energy-chart/energy-chart.component';
import {EnergyBalanceComponent} from './pages/dashboard/components/energy-balance/energy-balance.component';
import {ScheduleComponent} from './pages/schedule/schedule.component';
import {DevicesComponent} from './pages/devices/devices.component';
import {EnergyChartDebugComponent} from './pages/dashboard/components/energy-chart-debug/energy-chart-debug.component';
import {EnergyBalanceDebugComponent} from './pages/dashboard/components/energy-balance-debug/energy-balance-debug.component';
import {ChartComparisonDebugComponent} from './pages/chart-comparison-debug/chart-comparison-debug.component';
import {OptimizerForecastComponent} from './pages/optimizer-forecast/optimizer-forecast.component';
import {OptimizerComponent} from './pages/optimizer/optimizer.component';
import {ScheduleTranslatorDebuggerComponent} from './pages/schedule-translator-debugger/schedule-translator-debugger.component';
import {PriceDebuggerComponent} from './pages/price-debugger/price-debugger.component';
import {EnergyAdminComponent} from './pages/energy-admin/energy-admin.component';
import {PriceAdminComponent} from './pages/energy-admin/price-admin/price-admin.component';
import {LocationSettingsComponent} from './pages/energy-admin/location-settings/location-settings.component';
import {PriceChartComponent} from './pages/price-chart/price-chart.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: LayoutDefaultComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        title: 'Dashboard',
        component: DashboardComponent,
      },
      {
        path: 'energy-chart',
        title: 'Energy Chart',
        component: EnergyChartComponent,
      },
      {
        path: 'price-chart',
        title: 'Strom-Preis',
        component: PriceChartComponent,
      },
      {
        path: 'energy-balance',
        title: 'Energie Bilanz',
        component: EnergyBalanceComponent,
      },
      {
        path: 'devices',
        title: 'Devices',
        component: DevicesComponent,
      },

      // Interne Seiten. Sie sind absichtlich nicht im Kundenmenü verlinkt, der Index
      // unter /energy-admin ist der Einstieg.
      {
        path: 'energy-admin',
        title: 'Admin',
        children: [
          {
            path: '',
            component: EnergyAdminComponent,
          },
          {
            path: 'prices',
            title: 'Preise',
            component: PriceAdminComponent,
          },
          {
            path: 'location-settings',
            title: 'Standort-Einstellungen',
            component: LocationSettingsComponent,
          },
          {
            path: 'optimizer',
            title: 'Run Optimizer',
            component: OptimizerComponent,
          },
          {
            path: 'forecast-and-optimizer',
            title: 'Optimizer',
            component: OptimizerForecastComponent,
          },
          {
            path: 'energy-chart-debug',
            title: 'Energy Chart Debug',
            component: EnergyChartDebugComponent,
          },
          {
            path: 'energy-balance-debug',
            title: 'Energy Balance Debug',
            component: EnergyBalanceDebugComponent,
          },
          {
            path: 'chart-comparison-debug',
            title: 'Chart Comparison Debug',
            component: ChartComparisonDebugComponent,
          },
          {
            path: 'schedule',
            title: 'Schedule',
            component: ScheduleComponent,
          },
          {
            path: 'schedule-translator-debugger',
            title: 'Schedule Translator Debugger',
            component: ScheduleTranslatorDebuggerComponent,
          },
          {
            path: 'price-debugger',
            title: 'Price Debugger',
            component: PriceDebuggerComponent,
          },
        ],
      },

      // Alte Adressen der verschobenen Seiten, damit Lesezeichen weiter funktionieren.
      {
        path: 'optimizer',
        redirectTo: 'energy-admin/optimizer',
        pathMatch: 'full',
      },
      {
        path: 'forecast-and-optimizer',
        redirectTo: 'energy-admin/forecast-and-optimizer',
        pathMatch: 'full',
      },
      {
        path: 'energy-chart-debug',
        redirectTo: 'energy-admin/energy-chart-debug',
        pathMatch: 'full',
      },
      {
        path: 'energy-balance-debug',
        redirectTo: 'energy-admin/energy-balance-debug',
        pathMatch: 'full',
      },
      {
        path: 'schedule',
        redirectTo: 'energy-admin/schedule',
        pathMatch: 'full',
      },
      {
        path: 'schedule-translator-debugger',
        redirectTo: 'energy-admin/schedule-translator-debugger',
        pathMatch: 'full',
      },
      {
        path: 'price-debugger',
        redirectTo: 'energy-admin/price-debugger',
        pathMatch: 'full',
      },
    ],
  },
];
